import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { detectSafari } from 'yoda-core-components/lib/helpers/Utils/Utils';
import Dialog from 'yoda-core-components/lib/components/Dialog';
import { selectDeviceType } from '../../../../selectors/ContextSelector';
import * as styles from './EcoRebates.css';

const cx = classNames.bind(styles);

const EcoRebates = ({ skuId = '' }) => {
    const { isMobile } = useSelector((state) => selectDeviceType(state));
    const [showDialog, setShowDialog] = useState(false);

    const handleOnClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowDialog(true);
    };

    return skuId ? (
        <button
            className={dt([
                'cursor-pointer',
                'font-sans',
                'py-1',
                'text-black',
                'text-sm',
                'underline',
            ])}
            data-automation-id={`product-eco-rebate-${skuId}`}
            onClick={handleOnClick}
            type="button"
        >
            Rebates Available
            <Dialog
                aria-label="EcoRebates &copy;"
                body={
                    <iframe
                        className={dt(['h-full', 'w-full'])}
                        src={`https://jcpenney.ecorebates.com/ui/widgets/jcpenney/rebatedetails.html?ecr_skus=${skuId}&ecr_uiContext=PLP`}
                        style={{
                            maxWidth: isMobile ? null : '816px',
                            minWidth: '325px',
                            minHeight: detectSafari() ? '600px' : '0px',
                        }}
                        title="EcoRebates &copy;"
                    >
                        Content is not supported on this device
                    </iframe>
                }
                className={`${cx('dialog', {
                    mobile: isMobile,
                })} ${dt(['px-4', 'py-7'])}`}
                onDismiss={() => setShowDialog(false)}
                show={showDialog}
            />
        </button>
    ) : null;
};

EcoRebates.propTypes = {
    skuId: string.isRequired,
};

export default EcoRebates;
